export default {
    test({ state, commit, rootState }, data)
    {
        commit('test', data)
    },
    AllGradDegrees({ state, commit, rootState })
    {
        commit('AllGradDegrees')
    },
    getDegree({ state, commit, rootState }, data)
    {
        commit('getDegree', data)
    },
    getGradDegree({ state, commit, rootState }, data)
    {
        commit('getGradDegree', data)
    },

    AllExtensionDegrees({ state, commit, rootState }, data)
    {
        commit('AllExtensionDegrees', data)
    },
    AllUndergradDegrees({ state, commit, rootState })
    {
        commit('AllUndergradDegrees',rootState)
    },
    GetGraduateDegrees({state, commit, rootState}) {
        commit('GetGraduateDegrees', rootState)
    },
    GetAllPrograms({state, commit, rootState}){
        commit('GetCurrentPrograms', rootState)
    },
    GetGraduatePrograms({state, commit, rootState}, data){
        console.log(data)
        commit('GetGraduatePrograms', data)
    }
}
